var IndIdSelectionFactory = function ($resource, $window) {
  var retrieveAllPlansWithIndid =
    "/participant-web-services/rest/partialauth/userInfo/retrieveAllPlansWithIndid";
  var retrievePlansWithIndid =
    "/participant-web-services/rest/partialauth/userInfo/retrievePlansWithIndid";
  var selectIndId =
    "/participant-web-services/rest/indId/select/:individualId";

  return {
    retrieveAllPlansWithIndid: $resource(
      __baseApiUrl__ + retrieveAllPlansWithIndid,
      {},
      {
        query: {
          method: "GET"
        },
      }
    ),

    retrievePlansWithIndid: $resource(
      __baseApiUrl__ + retrievePlansWithIndid,
      {},
      {
        query: {
          method: "GET"
        },
      }
    ),

    selectIndId: $resource(
      __baseApiUrl__ + selectIndId,
      {
        individualId: "@individualId",
      },
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),
  };
};

IndIdSelectionFactory.$inject = ["$resource", "$window"];
export default IndIdSelectionFactory;
